export const FIELD_INPUT_CLASS =
  'block h-11 w-full rounded-lg border border-neutral-300 bg-white px-3 text-sm outline-none transition-colors focus:border-[var(--enroll-primary)] focus:ring-1 focus:ring-[var(--enroll-primary)] aria-[invalid=true]:border-red-400';
